// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"page_page-wrapper__m9anF","border-number":"page_border-number__nFMTf","orth":"page_orth__5zMbi"};